import React from 'react';
import { Line } from 'react-chartjs-2';
import { MetricsGrid } from '../Modals/localSeoStoreChartModal/MetricCard';
import Spinner from '../../../commons/components/utils/spinner/Spinner';
import { options } from '../localSeoStoreChart/LocalSeoStoreChart';
import { SearchCountBoxes } from '../Modals/localSeoStoreChartModal/SearchCountBoxes';

const LocalSeoStoreContent = ({ 
    store, 
    isLoading,
    chartData,
    keywordSearchCounts,
    t 
}) => {
    return (
        <div className="local-seo-store-content">
            {isLoading ? (
                <Spinner />
            ) : (
                <>
                    {/* 1. Gráfico */}
                    {chartData && (
                        <div className="chart-container">
                            <Line data={chartData} options={options(t)} />
                        </div>
                    )}

                    {/* 2. Keywords/Search counts */}
                    {keywordSearchCounts && (
                        <SearchCountBoxes 
                            searchCounts={keywordSearchCounts}
                            t={t}
                        />
                    )}

                    {/* 3. Métricas */}
                    <MetricsGrid 
                        store={store}
                        t={t} 
                    />
                </>
            )}
        </div>
    );
};

export default LocalSeoStoreContent;